import { createAction } from '@reduxjs/toolkit';
import {
  CREATE_FOLDER,
  DELETE_DOCUMENT,
  DELETE_FOLDER,
  GET_DOCUMENT,
  GET_DOCUMENTS,
  GET_FOLDER_DOCUMENTS,
  GET_FOLDER_OPTIONS,
  MOVE_DOCUMENT,
  UPDATE_DOCUMENT,
  UPDATE_FOLDER,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_PROGRESS
} from '../constants';

export const getDocuments = createAction(GET_DOCUMENTS);
export const getDocument = createAction(GET_DOCUMENT);
export const uploadDocument = createAction(UPLOAD_DOCUMENT);
export const uploadDocumentProgress = createAction(UPLOAD_DOCUMENT_PROGRESS);
export const updateDocument = createAction(UPDATE_DOCUMENT);
export const deleteDocument = createAction(DELETE_DOCUMENT);
export const getFolderDocuments = createAction(GET_FOLDER_DOCUMENTS);
export const getFolderOptions = createAction(GET_FOLDER_OPTIONS);
export const createFolder = createAction(CREATE_FOLDER);
export const updateFolder = createAction(UPDATE_FOLDER);
export const deleteFolder = createAction(DELETE_FOLDER);
export const moveDocument = createAction(MOVE_DOCUMENT);

export default {
  getDocuments,
  getDocument,
  uploadDocument,
  uploadDocumentProgress,
  updateDocument,
  deleteDocument,
  getFolderDocuments,
  getFolderOptions,
  createFolder,
  updateFolder,
  deleteFolder,
  moveDocument
};
